import { ButtonBase, styled } from '@mui/material';

export const CopyIcon = styled(ButtonBase)(({ theme }) => ({
	path: {
		fill: theme.darkMode ? theme.palette.common.white : theme.palette.common.black,
	},
}));
